import React from 'react'
import styled from 'styled-components'

import Environment from 'helpers/environment'

import { useSessionContext } from 'hooks/SessionContext'

import { color } from 'styles/colors'

const ENVIRONMENT_COLORS = {
  'Production': color('adminBannerProduction'),
  'Development': color('adminBannerDevelopment'),
  'Staging': color('adminBannerStaging'),
  'QA': color('adminBannerQA')
}

const ProductionBanner = () => {
  const { session } = useSessionContext()

  const environment =
    Environment.isProduction() ? 'Production'
      : Environment.isDevelopment() ? 'Development'
        : Environment.isStaging() ? 'Staging'
          : Environment.isQA() || Environment.isQA2() ? 'QA'
            : null

  return (
    <>
      {environment && (session.currentRole === 'admin' || session.isImpersonating) && (
        <S.Container environment={environment}>
          {Environment.name()} - Admin Access
        </S.Container>
      )}
    </>
  )
}

export default ProductionBanner

const S = {
  Container: styled.div <{ environment: string | null }>`
    width: -webkit-fill-available;
    background-color: ${({ environment }) => environment && ENVIRONMENT_COLORS[environment]};
    color: ${color('dangerText')};
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    position: fixed;
    z-index: 10000;
    top: 0;
    font-size: 10px;
    letter-spacing: 1px;
  `
}
